export default __webpack_public_path__ + "static/media/office3.6ee35539.jpg";